module.exports = __webpack_public_path__ + "img/rena_03.84e2fa47.png";